export default __webpack_public_path__ + "static/media/LentoLogo_Reverse.f244bb75.png";